import Client from "../client/Base"
const resource = "/api/v2"

const getChannels = (params) => {
  return Client.get(`${resource}/publish/topic/channel/`, { params })
}
const getBroadcast = (params) => {
  return Client.get(`${resource}/publish/broadcast/`, { params })
}
const getTopics = (params) => {
  return Client.get(`${resource}/publish/topic/`, { params })
}
const getEvents = (params) => {
  return Client.get(`${resource}/publish/app-config/`, { params })
}

const userRepository = {
  getChannels,
  getBroadcast,
  getTopics,
  getEvents
}

export default userRepository
